import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-table-card-action',
  templateUrl: 'table-card-action.component.html',
  styleUrls: ['table-card-action.component.scss']
})
export class TableCardActionComponent {
}
